/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


  // Add custom code below this line
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-item__size-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    
    const price = btn.dataset.variantPrice;
    const card = btn.closest('[data-grid-item]');
    if (!card) return;

    card.querySelectorAll('.product-item__size-btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    if (price) {
      const priceEl = card.querySelector('[data-product-price]');
      const formatted = (parseInt(price) / 100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
      if (priceEl) priceEl.innerHTML = '<span class="price">' + formatted + '</span>';
    }
  });

  // Filtra opcoes de variante ao acessar produto de colecao com tamanho fixo
  var colsize = new URLSearchParams(window.location.search).get('colsize');
  if (colsize) {
    function filterProductVariants() {
      document.querySelectorAll('select').forEach(function(sel) {
        sel.querySelectorAll('option').forEach(function(opt) {
          var txt = opt.textContent.trim();
          if ((txt === '100g' || txt === '200g' || txt === '400g') && txt !== colsize) {
            opt.disabled = true;
            opt.hidden = true;
          }
        });
      });
      document.querySelectorAll('input[type="radio"]').forEach(function(input) {
        var val = input.value;
        if ((val === '100g' || val === '200g' || val === '400g') && val !== colsize) {
          var wrapper = input.parentElement;
          if (wrapper) wrapper.style.display = 'none';
        }
      });
    }
    filterProductVariants();
    setTimeout(filterProductVariants, 800);
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
